import { cloneUserReducer } from 'src/app/admin/clone-user/store/reducers/clone.reducer';

export const cloneUserReducers = {
    cloneUserState: cloneUserReducer
};
